<template>
  <b-container class="w-100 my-5">
    <h2 class="title">
      {{ $t(`${plansPage}.${getExperience}.tags.licensesTitle`) }}
    </h2>
    <BrandsBlock :brands="brands" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BrandsBlock from '@/components/Common/BrandsBlock';

export default {
  name: 'LicensesBlock',
  components: {
    BrandsBlock
  },
  props: {
    lifetime: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => {
    return {
      brands: [
        {
          src: 'https://cdn.vexels.com/img/licensed-brands/merch-by-amazon2.png',
          alt: 'Merch by amazon'
        },
        { src: 'https://cdn.vexels.com/img/licensed-brands/printful2.png', alt: 'Printful' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/redbubble2.png', alt: 'Redbubble' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/teespring2.png', alt: 'Teespring' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/etsy2.png', alt: 'Etsy' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/zazzle2.png', alt: 'Zazzle' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/more2.png', alt: 'More' }
      ]
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    plansPage() {
      return this.lifetime ? 'lifetimePlans' : 'plans';
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-weight: 500;
  color: $strongGray;
}
</style>
